module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mainpage"
    }
  }, [_c('app-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "headerBlank"
    }
  }), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b0ee658"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/SpMainPage.vue
// module id = 681
// module chunks = 0